import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOneHiringAreaPediatricsNeonatology = () => {
    return (
        <>
            <section className="hiring-area pt-120 pb-120">
                <div className="container">
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. B. D. Bhatia.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. B. D. BHATIA</h1>
                                <p>
                                    MBBS, MD, DCH, FIAP, FNNF, FAMS, FICN
                                    <br />
                                    50 years of Experience Ex. Prof., Dean & Head (IMS, BHU)
                                    <br />
                                    Ex. Prof. & Head - Paediatrics (Heritage Medical College & Hospital, Vns)
                                    <br />
                                    Ex. Prof. Head & MS (Universal College of Medical Science, Nepal) | President – NNF
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. AMITA SRIVASTAVA</h1>
                                <p>
                                    M.B.B.S., DCH (KGMU, LUCKNOW)
                                    <br />
                                    18 Years of Experience in Paediatrics & Neonatal ICU
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon ml-0"><span>+</span>Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Amita Srivastava.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Kishor Jaishi.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. KISHOR JAISHI</h1>
                                <p>
                                    M.B.B.S. (KGMU, LUCKNOW) DCH (MGMC, INDORE) PICU FELLOWSHIP (Rainbow children hospital hyderabad) NICU FELLOWSHIP (Motherhood Hospital, Banglore) 11 YEARS OF EXPERIENCE
                                    <br />
                                    PAEDIATRIC & NEONATAL ICU
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>DR. BAL KRISHNA TRIPATHI</h1>
                                <p>
                                    M.B.B.S., MS, MCH
                                    <br />
                                    10 YEARS OF EXPERIENCE
                                    <br />
                                    More than 5000 surgeries
                                    <br />
                                    PAEDIATRIC SURGEON & UROLOGIST
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon ml-0"><span>+</span>Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Bal Krishna Tripati.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Renu.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. RENU</h1>
                                <p>
                                    M.B.B.S., MD, (PEDIATRICS)
                                    <br />
                                    SENIOR RESIDENT (PEDIATRICS)
                                    <br />
                                    AIIMS, RISHIKESH
                                    <br />
                                    PAED ONCOLOGIST - TMH VARNASI
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesOneHiringAreaPediatricsNeonatology;